/**
 * BCC France — Hero slideshow.
 *
 * Cycles through .hero__slide elements by toggling the .is-active class
 * every 3 seconds with a 1-second CSS opacity crossfade.
 *
 * Does nothing if there is only one slide (static display, no interval).
 * PHP renders the first slide with .is-active so content is visible before
 * JS runs.
 */

/**
 * Initialise the hero slideshow.
 * Called from app.js on DOMContentLoaded.
 */
export function initHeroSlideshow() {
  const slides = Array.from( document.querySelectorAll( '.hero__slide' ) );

  // No slideshow needed when there is only one image (or none).
  if ( slides.length <= 1 ) return;

  let current = 0;

  setInterval( () => {
    slides[ current ].classList.remove( 'is-active' );
    current = ( current + 1 ) % slides.length;
    slides[ current ].classList.add( 'is-active' );
  }, 3000 );
}
